import { LOGBOOK_ROLES } from '@components/cockpit/cockpit.types';
import { useAppSelector } from '@hooks/redux.hooks';
import { hasAnyRoles, hasRole } from '@redux/authent/authent.selectors';
import { RootState } from '@redux/store';

import { RoleEnum } from '@/types/authent/roles.types';

import Chat from '../chat/Chat';
import LogBook from '../logbook/LogBook';

export default function LogbookAndChat() {
  const canSeeChat = useAppSelector((state: RootState) => hasRole(state, RoleEnum.ACCESS_MSG));
  const canSeeLogBook = useAppSelector((state) => hasAnyRoles(state, LOGBOOK_ROLES));
  return (
    <>
      {canSeeLogBook && <LogBook />}
      {canSeeChat && <Chat />}
    </>
  );
}
